//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './QualificationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetQualificationQueryParameters = {
  participant?: string | null | undefined ;
  description?: string | null | undefined ;
  isValid?: boolean | undefined ;
  isExpireSoon?: boolean | undefined ;
  isExpired?: boolean | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type SyncQualificationsQualificationQueryParameters = {
  executeJobFrom?: Date | null | undefined ;
  dryRun?: boolean | undefined ;
}

export function getUrl(participant?: string | null | undefined, description?: string | null | undefined, isValid?: boolean | undefined, isExpireSoon?: boolean | undefined, isExpired?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/qualifications?";
if (participant !== undefined && participant !== null)
    url_ += "Participant=" + encodeURIComponent("" + participant) + "&";
if (description !== undefined && description !== null)
    url_ += "Description=" + encodeURIComponent("" + description) + "&";
if (isValid === null)
    throw new Error("The parameter 'isValid' cannot be null.");
else if (isValid !== undefined)
    url_ += "IsValid=" + encodeURIComponent("" + isValid) + "&";
if (isExpireSoon === null)
    throw new Error("The parameter 'isExpireSoon' cannot be null.");
else if (isExpireSoon !== undefined)
    url_ += "IsExpireSoon=" + encodeURIComponent("" + isExpireSoon) + "&";
if (isExpired === null)
    throw new Error("The parameter 'isExpired' cannot be null.");
else if (isExpired !== undefined)
    url_ += "IsExpired=" + encodeURIComponent("" + isExpired) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfQualificationResponseDto, unknown, Types.PagedResultOfQualificationResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfQualificationResponseDto, unknown, Types.PagedResultOfQualificationResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetQualificationQueryParameters): QueryKey;
export function getQueryKey(participant?: string | null | undefined, description?: string | null | undefined, isValid?: boolean | undefined, isExpireSoon?: boolean | undefined, isExpired?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { participant, description, isValid, isExpireSoon, isExpired, offset, limit, sortBy, sortOrder,  } = params[0] as GetQualificationQueryParameters;

    return trimArrayEnd([
        'QualificationClient',
        'get',
        participant as any,
        description as any,
        isValid as any,
        isExpireSoon as any,
        isExpired as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'QualificationClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as boolean | undefined,       context.queryKey[5] as boolean | undefined,       context.queryKey[6] as boolean | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as string | null | undefined,       context.queryKey[10] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PagedResultOfQualificationResponseDto, TError = unknown>(dto: GetQualificationQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfQualificationResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get qualifications
 * @param participant (optional) 
 * @param description (optional) 
 * @param isValid (optional) 
 * @param isExpireSoon (optional) 
 * @param isExpired (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.PagedResultOfQualificationResponseDto, TError = unknown>(participant?: string | null | undefined, description?: string | null | undefined, isValid?: boolean | undefined, isExpireSoon?: boolean | undefined, isExpired?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfQualificationResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PagedResultOfQualificationResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfQualificationResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let participant: any = undefined;
  let description: any = undefined;
  let isValid: any = undefined;
  let isExpireSoon: any = undefined;
  let isExpired: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ participant, description, isValid, isExpireSoon, isExpired, offset, limit, sortBy, sortOrder,  } = params[0] as GetQualificationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [participant, description, isValid, isExpireSoon, isExpired, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfQualificationResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(participant, description, isValid, isExpireSoon, isExpired, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfQualificationResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get qualifications
 * @param participant (optional) 
 * @param description (optional) 
 * @param isValid (optional) 
 * @param isExpireSoon (optional) 
 * @param isExpired (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.PagedResultOfQualificationResponseDto | undefined) => Types.PagedResultOfQualificationResponseDto, participant?: string | null | undefined, description?: string | null | undefined, isValid?: boolean | undefined, isExpireSoon?: boolean | undefined, isExpired?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(participant, description, isValid, isExpireSoon, isExpired, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Get qualifications
 * @param participant (optional) 
 * @param description (optional) 
 * @param isValid (optional) 
 * @param isExpireSoon (optional) 
 * @param isExpired (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfQualificationResponseDto | undefined) => Types.PagedResultOfQualificationResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function syncQualificationsUrl(executeJobFrom?: Date | null | undefined, dryRun?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/qualifications/update?";
if (executeJobFrom !== undefined && executeJobFrom !== null)
    url_ += "executeJobFrom=" + encodeURIComponent(executeJobFrom ? "" + executeJobFrom.toISOString() : "") + "&";
if (dryRun === null)
    throw new Error("The parameter 'dryRun' cannot be null.");
else if (dryRun !== undefined)
    url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function syncQualificationsMutationKey(executeJobFrom?: Date | null | undefined, dryRun?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'QualificationClient',
      'syncQualifications',
      executeJobFrom as any,
      dryRun as any,
    ]);
}

/**
 * Update qualifications
 * @param executeJobFrom (optional) If specified, fetches qualifications updated after this date.
            Otherwise, the latest UpdatedAt from the database is used.
 * @param dryRun (optional) If true, fetched qualifications will not be persisted to the database.
 */
export function useSyncQualificationsMutation<TContext>(executeJobFrom?: Date | null | undefined, dryRun?: boolean | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = syncQualificationsMutationKey(executeJobFrom, dryRun);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.syncQualifications(executeJobFrom, dryRun),
    mutationKey: key,
  });
}
  
type SyncQualifications__MutationParameters = SyncQualificationsQualificationQueryParameters

/**
 * Update qualifications
 * @param executeJobFrom (optional) If specified, fetches qualifications updated after this date.
            Otherwise, the latest UpdatedAt from the database is used.
 * @param dryRun (optional) If true, fetched qualifications will not be persisted to the database.
 */
export function useSyncQualificationsMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SyncQualifications__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SyncQualificationsQualificationQueryParameters}): UseMutationResult<void, unknown, SyncQualifications__MutationParameters, TContext> {
  const key = syncQualificationsMutationKey(options?.parameters?.executeJobFrom!, options?.parameters?.dryRun!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SyncQualifications__MutationParameters) => Client.syncQualifications(data.executeJobFrom ?? options?.parameters?.executeJobFrom!, data.dryRun ?? options?.parameters?.dryRun!),
  mutationKey: key,
});
}
  
export function notifyAndUpdateQualificationsUrl(): string {
  let url_ = getBaseUrl() + "/api/qualifications/notify-and-update";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function notifyAndUpdateQualificationsMutationKey(): MutationKey {
  return trimArrayEnd([
      'QualificationClient',
      'notifyAndUpdateQualifications',
    ]);
}

/**
 * Sends qualification emails and updates qualification notification dates.
 */
export function useNotifyAndUpdateQualificationsMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.QualificationNotificatorJobSettings, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.QualificationNotificatorJobSettings, TContext> {
  const key = notifyAndUpdateQualificationsMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (settings: Types.QualificationNotificatorJobSettings) => Client.notifyAndUpdateQualifications(settings),
    mutationKey: key,
  });
}